import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Compatibility redirect from the old "/settings/rp" tab path.
 * The Relying Party tab was folded into Authentication; the one
 * editable knob it owned (`user_verification`) lives in the
 * Passkey policy section. This redirect preserves any operator
 * bookmarks or in-house wiki links to the old URL — they land on
 * the Authentication tab instead of a 404.
 */
export const Route = createFileRoute("/_authed/tenants/$slug/settings/rp")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/tenants/$slug/authentication/sign-in",
      params: { slug: params.slug },
      replace: true,
    });
  },
});
